import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import Head from 'next/head';
import { useRouter } from 'next/router';

import UniModal from '@components/UniModal';
import { Button } from '@components';

import { pageview } from '../../lib/gtm';

import TrackerComp from '../tracker';
import BbMonitor from '../bb-monitor';
import OnLoadNLogin from '../bb-onLoadNLogin';
import Rates from '../bb-TabFocus/bb-rates';
import CFooter from '../bb-footer';
import CHeader from '../bb-header';
// import WhatsNew from '../bb-whatsNew';

const Layout = ({ children, ...props }) => {
	const { asPath, events } = useRouter();

	useEffect(() => {
		events.on('routeChangeComplete', pageview);
		return () => {
			events.off('routeChangeComplete', pageview);
		};
	}, [events]);

	return (
		<div className="stickyFooter-parent">
			<CHeader
				minimal={/^(\/how-to-inr-deposit-to-buy-digital-currency|\/how-lend-digital-currency-make-profit-bitbns)$/.test(
					asPath
				)}
			/>
			<Head>
				<meta
					name="viewport"
					content="width=device-width, initial-scale=1, shrink-to-fit=no, user-scalable=yes"
				/>
			</Head>
			<TrackerComp />
			<BbMonitor />
			<div>{children}</div>
			<OnLoadNLogin />
			<Rates />
			{/* <WhatsNew /> */}
			<CFooter
				minimal={/^(\/how-to-inr-deposit-to-buy-digital-currency|\/how-lend-digital-currency-make-profit-bitbns)$/.test(
					asPath
				)}
			/>
			<ToastContainer
				closeButton={
					<Button
						variant="minimal"
						size="tiny"
						className="text-3xl font-normal p-2 leading-x self-start"
						type="button"
						aria-label="close"
					>
						&times;
					</Button>
				}
			/>
			<UniModal />
		</div>
	);
};

export default Layout;
